import { TabInterface } from "components/layout/interfaces";
import Tabs from "components/layout/tabs";
import View from "components/layout/view";
import Title from "components/title";
import { parse } from "lib/locale";
import { FunctionComponent } from "react";
import { useList } from "stores/hooks/list";
import { useListUser } from "stores/hooks/list-user";
import { useLocale } from "stores/hooks/locale";
import ListUserBaseTab from "./tabs/base/base-tab";
import ListUserEmailHistoryTab from "./tabs/email-history/email-history-tab";

const AdminListUserView: FunctionComponent = () => {
  const locale = useLocale();
  const list = useList();
  const listUser = useListUser();

  if (!list || !listUser) {
    return null;
  }

  let userName = [listUser.firstname, listUser.lastname].join(" ");
  if (userName.trim().length === 0) {
    userName = listUser.email;
  }

  const tabs: TabInterface[] = [
    {
      key: "base",
      label: "Ilmoituksen tiedot",
      render: () => <ListUserBaseTab />,
    },
    {
      key: "email",
      label: "Sähköpostihistoria",
      render: () => <ListUserEmailHistoryTab />,
    },
    {
      key: "logs",
      label: "Muutoshistoria",
      render: () => <div>audit lokista tätä käyttäjää koskeva osuus</div>,
    },
  ];

  const title = [parse(list.name, locale), userName].join(": ");
  return (
    <View title={title}>
      <Title>{title}</Title>
      <Tabs name={`user-${listUser.uuid}`} tabs={tabs} />
    </View>
  );
};

export default AdminListUserView;
